<script setup lang="ts">
import type { FunctionalComponent } from 'vue'

const props = withDefaults(
  defineProps<{
    variant?: 'primary' | 'ghost' | 'outline'
    leftIcon?: FunctionalComponent
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
  }>(),
  {
    variant: 'primary',
    type: 'button',
  },
)
</script>

<template>
  <button
    :type="props.type"
    :disabled="props.disabled"
    class="inline-flex items-center gap-2 rounded-brand border px-4 py-2 text-sm font-semibold transition"
    :class="{
      'border-primary bg-primary text-white hover:opacity-90 disabled:opacity-50': props.variant === 'primary',
      'border-transparent bg-transparent text-text hover:bg-primary/10': props.variant === 'ghost',
      'border-border bg-surface text-text hover:border-primary/40': props.variant === 'outline',
    }"
  >
    <component :is="props.leftIcon" v-if="props.leftIcon" class="h-4 w-4" />
    <slot />
  </button>
</template>
